import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { GameTextUtil } from "../../../utils/GameTextUtil";
import { ViewProperties } from "../../../utils/ViewProperties";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
/**
 * Properties for a note describing win line information.
 */
export class GameWinLineNoteProperties extends ViewProperties {
    constructor() {
        super();
        this.backgroundProperties = new SpriteProperties(GameStyle.WIN_LINE_PANEL, GameStyle.MODULE);
        this.symbolCountProperties = [
            new TextFieldProperties(GameFontStyle.SCATTER_PANEL_COUNT_MAX, new Point(51, 111), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(30, 52)),
            new TextFieldProperties(GameFontStyle.SCATTER_PANEL_COUNT_MID, new Point(51, 158), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(30, 52)),
            new TextFieldProperties(GameFontStyle.SCATTER_PANEL_COUNT_MIN, new Point(51, 204), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(30, 52)),
        ];
        this.numberPayoutProperties = yPositions.map(y => new TextFieldProperties(GameFontStyle.SCATTER_PANEL_FIELD, new Point(148, y), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(124, 52)));
        this.jokerPayoutProperties = yPositions.map(y => new TextFieldProperties(GameFontStyle.SCATTER_PANEL_FIELD, new Point(298, y), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(124, 52)));
        GameTextUtil.centerProperties(...this.symbolCountProperties, ...this.numberPayoutProperties, ...this.jokerPayoutProperties);
    }
}
const yPositions = [110, 156, 202];
//# sourceMappingURL=GameWinLineNoteProperties.js.map